module.exports = __webpack_public_path__ + "static/media/focusedVoice.494c21d7.svg";